<script>
  import {
    getXeroStatusTitle
  } from '@utils/xero'

  import {
    userMethods
  } from '@state/helpers'

  export default {
    props: {
      mapping: {
        type: Object,
        default: null,
      },
      isLoading: {
        type: Boolean,
        default: false,
      }
    },
    methods: {
      ...userMethods,
      getXeroStatusTitle,
      getXeroLink (mapping) {
        let domain = '';
        switch(mapping.type) {
          case "SaleOrder":
            domain = 'https://go.xero.com/Accounts/Receivable/Quotes/Edit/';
            break;
          case "PurchaseOrder":
          case "InternalPurchaseOrder":
            domain = 'https://go.xero.com/Accounts/Payable/PurchaseOrders/Edit/';
            break;
          case "InvoiceOrder":
            domain = 'https://invoicing.xero.com/edit/';
            break;
        }

        return domain + mapping.xero_id
      }
    }
  }
</script>

<template>
  <div v-if="isXeroConnected()" class="tw-mr-3">
    <span v-if="!isLoading" class="fl-inline">
      <span class="info-tooltip" >
        <img id="xero-img-info" :title="getXeroStatusTitle(mapping)" src="@assets/images/info.svg" />
        <FabricTooltip 
          target="xero-img-info" 
          triggers="hover">
          {{ getXeroStatusTitle(mapping) }}
        </FabricTooltip>
      </span>

      <a v-if="mapping && mapping.status === 'success'" :href="getXeroLink(mapping)" target="_blank">
        <img
          id="xero-img-success"
          class="xero-sync-status"
          title="Click here to see the details on Xero."
          src="@assets/images/xero-success.svg"/>
        <FabricTooltip 
          target="xero-img-success" 
          triggers="hover">
          Click here to see the details on Xero.
        </FabricTooltip>
      </a>

      <a v-else-if="mapping && mapping.status === 'fail_account_code'" href="javascript:void(0)" @click="$emit('sync')">
        <img
          id="xero-img-fail"
          class="xero-sync-status"
          title="Click here to re-sync data to Xero. The status will be updated within 10 seconds."
          src="@assets/images/xero-fail-account-code.svg"/>
        <FabricTooltip 
          target="xero-img-fail" 
          triggers="hover">
          Click here to re-sync data to Xero. The status will be updated within 10 seconds.
        </FabricTooltip>
      </a>
        
      <a v-else-if="mapping && mapping.status === 'pending'" href="javascript:void(0)" >
        <img
          id="xero-img-pending"
          class="xero-sync-status"
          title="This document has not been synced to Xero yet."
          src="@assets/images/xero-pending.svg"/>
        <FabricTooltip 
          target="xero-img-pending" 
          triggers="hover">
          This document has not been synced to Xero yet.
        </FabricTooltip>
      </a>

      <a v-else href="javascript:void(0)" @click="$emit('sync')">
        <img
          id="xero-img-resync"
          class="xero-sync-status"
          title="Click here to re-sync data to Xero. The status will be updated within 10 seconds."
          src="@assets/images/xero-fail.svg"/>
        <FabricTooltip 
          target="xero-img-resync" 
          triggers="hover">
          Click here to re-sync data to Xero. The status will be updated within 10 seconds.
        </FabricTooltip>
      </a>

    </span>
    <span v-else>
      <img
        id="xero-img-loading"
        class="xero-sync-status"
        title="Xero Data is currently loading"
        src="@assets/images/loading.svg"/>
      <FabricTooltip 
        target="xero-img-loading" 
        triggers="hover">
        Xero Data is currently loading
      </FabricTooltip>
    </span>
  </div>
</template>
